/**
 * MatrixCostSummary - Inline cost summary for matrix batch
 */

import type { MatrixItem } from '@/lib/api/batch';

interface MatrixCostSummaryProps {
  items: MatrixItem[];
  totalGenerations: number;
  costPerImage: number;
  costPerImage4k: number;
  discountPercent: number;
  getItemGenerations: (item: MatrixItem) => number;
}

export function MatrixCostSummary({
  items,
  totalGenerations,
  costPerImage,
  costPerImage4k,
  discountPercent,
  getItemGenerations,
}: MatrixCostSummaryProps) {
  if (items.length === 0) return null;

  const has4k = items.some((i) => i.output_resolution === 4096);
  let total = 0;
  for (const item of items) {
    const gens = getItemGenerations(item);
    total += gens * (item.output_resolution === 4096 ? costPerImage4k : costPerImage);
  }

  return (
    <div className="flex items-center justify-between px-2 py-1.5 rounded bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800">
      <span className="text-xs text-orange-700 dark:text-orange-300">
        {totalGenerations} Bilder × {has4k ? `${costPerImage}–${costPerImage4k}` : costPerImage} Credits
        {discountPercent > 0 && ` (${discountPercent}% Rabatt)`}
      </span>
      <span className="text-sm font-bold text-orange-600 dark:text-orange-400">
        {total} Credits
      </span>
    </div>
  );
}
